import React from 'react';
import PropTypes from 'prop-types';

const PrescriptionList = ({ prescriptions, currentUserId, onEdit }) => {
  if (prescriptions.length === 0) {
    return <p>No prescriptions found.</p>;
  }

  return (
    <div className="prescription-grid">
      {prescriptions.map((prescription) => (
        <div
          key={prescription.id}
          className="item w-full"
        >

          <div>
            {prescription.medication_items && prescription.medication_items.length > 0 ? (
              <ol className="prescription-list-items">
                {prescription.medication_items.map((item) => (
                  <li key={item.id}>
                    <strong>{item.medication_name}</strong>
                    {'   '}
                    —
                    {item.dosage}
                    ,
                    {'   '}
                    {item.frequency}
                    ,
                    {'   '}
                    {item.duration}
                    {'   '}
                    {item.instruction && ` (${item.instruction})`}
                  </li>
                ))}
              </ol>
            ) : (
              <p className="italic text-sm text-gray-500">No medication items listed.</p>
            )}

          </div>

          <div>
            <p className="text-sm text-gray-500 mt-2">
              {(() => {
                const date = new Date(prescription.created_at);
                const day = date.getDate();
                const weekday = date.toLocaleDateString('en-US', { weekday: 'short' });
                const month = date.toLocaleDateString('en-US', { month: 'long' });
                const time = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });

                return `Created: ${day} ${weekday} ${month} ${time}`;
              })()}
            </p>

            {prescription.user_id === currentUserId && (
            <button
              type="button"
              onClick={() => onEdit(prescription)}
              className="primary text-sm mx-auto mt-1"
            >
              Edit
            </button>
            )}

          </div>

        </div>
      ))}
    </div>

  );
};

PrescriptionList.propTypes = {
  prescriptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      created_at: PropTypes.string.isRequired,
      user_id: PropTypes.number.isRequired,
      medication_items: PropTypes.arrayOf(
        PropTypes.shape({
          medication_name: PropTypes.string.isRequired,
          dosage: PropTypes.string,
          frequency: PropTypes.string,
          duration: PropTypes.string,
          instruction: PropTypes.string,
        }),
      ),
    }),
  ).isRequired,
  currentUserId: PropTypes.number.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default PrescriptionList;
